import axios from "axios";

export const globalHeaders = { "Content-Type": "application/json" };

export function setGlobalHeader(name, value) {
  if (value === null || value === undefined) {
    delete globalHeaders[name];
  } else {
    globalHeaders[name] = value;
  }
}

axios.interceptors.request.use((config) => {
  const merged = { ...globalHeaders, ...config.headers };
  if (!merged.Authorization) {
    delete merged.Authorization;
  }
  config.headers = merged;
  return config;
});

export { axios };
